// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3aegs","productName":"Table_productName__29wDp"};